import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { ProjectFragmentDoc } from '../../fragments/__generated__/project';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    
export type GetProjectsQueryVariables = Types.Exact<{
  user_id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  code?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProjectsQuery = { __typename?: 'Query', projects?: Array<{ __typename?: 'Project', id: string, code: string, status?: Types.ProjectStatusEnum | null, sector?: string | null, created_at?: number | null, updated_at?: number | null, name?: string | null, background_info?: string | null, background?: { __typename?: 'File', base64: string, path: string, filename: string, width?: number | null, height?: number | null, type: string, size: number } | null, schema?: { __typename?: 'File', filename: string, path: string } | null, preview?: { __typename?: 'File', filename: string, path: string } | null, user?: { __typename?: 'User', id: string, name?: string | null, city?: string | null, email: string, active: boolean, company?: string | null, is_admin: boolean } | null }> | null };


export const GetProjectsDocument = gql`
    query GetProjects($user_id: ID, $code: String) {
  projects(user_id: $user_id, code: $code) {
    ...project
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;